import Swiper, { Navigation, Thumbs } from 'swiper';

Swiper.use([Navigation, Thumbs]);

const SWIPER_MAIN_CLASS = 'swiper-main';
const SWIPER_THUMB_CLASS = 'swiper-thumb';

const InitializeProfileSwiper = (uniqueClassMain, uniqueClassThumb) => {
    const thumbClass = `.profile-carousel-block ${uniqueClassThumb ? `.${uniqueClassThumb}` : '.swiper-thumb'}`;
    const thumbSwiper = new Swiper(thumbClass, {
        spaceBetween: 16,
        direction: 'vertical',
        allowTouchMove: false,
        // swiper navigation is only used on horizontal slides (on tablet), a custom navigation is used on vertical slides
        navigation: {
            nextEl: `${thumbClass} .swiper-button-next`,
            prevEl: `${thumbClass} .swiper-button-prev`
        },
        breakpoints: {
            768: {
                direction: 'horizontal',
                slidesPerView: 2.5,
                slidesPerGroup: 2,
                allowTouchMove: true
            },
            1024: {
                direction: 'vertical',
                allowTouchMove: false
            }
        }
    });

    const mainClass = `.profile-carousel-block ${uniqueClassMain ? `.${uniqueClassMain}` : '.swiper-main'}`;
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const mainSwiper = new Swiper(mainClass, {
        spaceBetween: 24,
        autoHeight: true,
        thumbs: { swiper: thumbSwiper },
        direction: 'horizontal',
        allowTouchMove: false,
        on: {
            slideChange: () => {
                const mainSlide = document.querySelectorAll('.swiper-main .swiper-slide');
                mainSlide.forEach(slide => {
                    const youtubePlayer = slide.querySelector('iframe');
                    if (youtubePlayer) {
                        youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    }
                });
            }
        }
    });

    // initialize vertical scroll navigation for mobile and desktop
    const nextArrow = document.querySelector(`${thumbClass} .vertical-button-next`);
    const prevArrow = document.querySelector(`${thumbClass} .vertical-button-prev`);

    const thumbnailSlide = document.querySelector(`${thumbClass} .swiper-wrapper`);
    const mainSlide = document.querySelector(`${mainClass} .swiper-wrapper`);

    let activeSlideScrollPos = 0;

    toggleSwiperDisplay(thumbnailSlide, mainSlide, thumbClass);
    updateNavButtons(thumbnailSlide, nextArrow, prevArrow);

    // scroll thumnail wrapper on arrow click
    nextArrow.addEventListener('click', () => {
        thumbnailSlide.scrollTop += (thumbnailSlide.scrollHeight / 3);
    });

    prevArrow.addEventListener('click', () => {
        thumbnailSlide.scrollTop -= (thumbnailSlide.scrollHeight / 3);
    });

    // update scroll position of active slide
    thumbnailSlide.addEventListener('click', () => {
        activeSlideScrollPos = thumbnailSlide.scrollTop;
    });

    // update button state on beginning and end of wrapper
    thumbnailSlide.addEventListener('scroll', () => {
        updateNavButtons(thumbnailSlide, nextArrow, prevArrow);
    });

    window.addEventListener('resize', () => {
        // scroll to active thumbnail slide
        if (thumbnailSlide.scrollTop === 0) {
            thumbnailSlide.scrollTop = activeSlideScrollPos;
        }
        setTimeout(() => {
            toggleSwiperDisplay(thumbnailSlide, mainSlide, thumbClass);
            updateNavButtons(thumbnailSlide, nextArrow, prevArrow);
        }, 10);
    });
};

// checks if the current scroll position is at the most top or bottom, update button state accordingly
const updateNavButtons = (container, nextBtn, prevBtn) => {
    if (Math.ceil(container.scrollTop) === (container.scrollHeight - container.clientHeight)) {
        nextBtn.classList.add('vertical-button-disabled');
    } else {
        nextBtn.classList.remove('vertical-button-disabled');
    }

    if (container.scrollTop === 0) {
        prevBtn.classList.add('vertical-button-disabled');
    } else {
        prevBtn.classList.remove('vertical-button-disabled');
    }
};

// adjust slide display and styling
const toggleSwiperDisplay = (thumbnailSlide, mainSlide, thumbnailClass) => {
    // hide/show thumbnail slide controls depending on client and scroll height
    // only applicable on vertical sliders (mobile and desktop)
    if (!(window.innerWidth >= 768 && window.innerWidth < 1024)) {
        // set thumbnail wrapper height same as the height of the main slide wrapper
        // note: 72px is the height+margin top of the swiper controller
        if (window.innerWidth >= 1024) {
            const height = parseInt(mainSlide.style.height.replace('px', ''), 10) - 72;
            thumbnailSlide.setAttribute('style', `height:${height}px`);
        } else {
            thumbnailSlide.setAttribute('style', 'height:460px');
        }

        if (thumbnailSlide.scrollHeight <= thumbnailSlide.clientHeight) {
            document.querySelector(`${thumbnailClass} .swiper-controls`).classList.add('hidden');
        } else {
            document.querySelector(`${thumbnailClass} .swiper-controls`).classList.remove('hidden');
        }
    } else {
        thumbnailSlide.setAttribute('style', 'height:auto');
        document.querySelector(`${thumbnailClass} .swiper-controls`).classList.remove('hidden');
    }
};

const PrepareProfileCarousel = () => {
    const mcBlocks = document.querySelectorAll('.profile-carousel-block');

    mcBlocks.forEach((mcBlock, index) => {
        const mainSwiper = mcBlock.querySelector('.swiper-main');
        const mainSwiperWrapper = mainSwiper ? mainSwiper.querySelector('.swiper-main .swiper-wrapper') : null;
        const thumbnail = mcBlock.querySelector('.profile-thumbnail-template .profile-thumbnail');

        if (mainSwiperWrapper) {
            const swiperSlides = mainSwiperWrapper.querySelectorAll('.swiper-slide');

            const thumbSwiper = mcBlock.querySelector('.swiper-thumb');
            const thumbSwiperWrapper = thumbSwiper.querySelector('.swiper-wrapper');

            if (swiperSlides.length < 2) {
                const swiperContainer = mcBlock.querySelector('.profile-carousel-container');
                // less than two slide, hide thumbnail
                swiperContainer.classList.add('one-slide');
                thumbSwiper?.classList.add('hidden');
            } else {
                // more than one slide, copy slides to thumbnail carousel
                const uniqueClassMain = `${SWIPER_MAIN_CLASS}-${index}`;
                const uniqueClassThumb = `${SWIPER_THUMB_CLASS}-${index}`;
                mainSwiper?.classList.add(uniqueClassMain);
                thumbSwiper?.classList.add(uniqueClassThumb);

                swiperSlides.forEach(slide => {
                    // get slide cover image for thumbnail
                    const slideImage = slide.cloneNode(true).querySelector('.image-wrapper');

                    // get video embed info
                    const slideHeading = slide.querySelector('.video-embed-info-heading')?.textContent;
                    const slideSubheading = slide.querySelector('.video-embed-info-subheading')?.textContent;

                    // add class for styling
                    slideImage.classList.add('profile-thumbnail-image-container');

                    const slideThumbnail = thumbnail.cloneNode(true);
                    slideThumbnail.insertBefore(slideImage, slideThumbnail.firstChild);
                    slideThumbnail.querySelector('.profile-thumbnail-heading').textContent = slideHeading;
                    slideThumbnail.querySelector('.profile-thumbnail-subheading').textContent = slideSubheading;

                    if (slideSubheading) {
                        slideThumbnail.querySelector('.profile-thumbnail-subheading').textContent = slideSubheading;
                    }

                    thumbSwiperWrapper.append(slideThumbnail);
                });
                InitializeProfileSwiper(uniqueClassMain, uniqueClassThumb);
            }
        }
    });
};

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', PrepareProfileCarousel);
